import { Field, useField } from "formik";
import React from "react";
import FormField from "./FormField";

const RadioField = ({
  name,
  label,
  value,
  hideErrorMessage = false,
  ...rest
}) => {
  const [, meta] = useField(name);

  return (
    <FormField label="" name={name} hideErrorMessage={hideErrorMessage}>
      <label className="flex items-start gap-2">
        <Field
          type="radio"
          name={name}
          value={value}
          className={`mt-1 h-4 w-4 rounded-full text-primary focus:ring-primary ${meta.touched && meta.error ? "border-red-500" : "border-gray-300"}`}
          {...rest}
        />
        <span className="flex-1">{label}</span>
      </label>
    </FormField>
  );
};

export default RadioField;
